'use strict';
'use client';
import { j as e } from "../../../external/react/jsx-runtime.js";
import { faBullseye as i, faDumbbell as n, faUserDoctor as d, faFire as c } from "../../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { FontAwesomeIcon as m } from "../../../external/@fortawesome/react-fontawesome/index.es.js";
import a from "../../../external/classnames/index.js";
import { useTheme as f } from "../../Provider/index.js";
const l = [
  {
    icon: i,
    title: "Starting dose",
    description: "Your treatment will begin at a starting dose for the first 4 weeks to allow your body to adapt to the treatment and reduce any side effects."
  },
  {
    icon: n,
    title: "Step up dose",
    description: "Your dosage will increase slightly to ensure your body’s tolerance towards the medication and improve its effectiveness. "
  },
  {
    icon: d,
    title: "Treatment check in",
    description: "After your increase in dosage, you will do a check in quiz to let us know how you’re tracking with the treatment"
  },
  {
    icon: c,
    title: "Visible results",
    description: "After your body has adjusted to your treatment, your practitioner will assign a maintenance dose and you’ll begin to see the full weight loss benefits of the treatment"
  }
], y = () => {
  const { isMosh: t, isMoshy: s } = f();
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ e.jsx(
        "h2",
        {
          className: a({
            "text-green-dark": t,
            "text-black": s
          }),
          children: "Your treatment plan timeline"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "span",
        {
          className: a("p2", {
            "text-green-dark": t,
            "text-grey-400": s
          }),
          children: "Titrating medication involves carefully adjusting the dosage over the course of a few months to achieve the best results while minimising side effects."
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-8 md:w-full md:flex-row", children: l.map((o, r) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: a(
          "relative flex flex-col gap-2 rounded-2xl border border-grey-200 p-4 md:grow md:basis-0",
          {
            "!border-green": t && r === l.length - 1,
            "!border-blue": s && r === l.length - 1,
            "shadow-md": r === l.length - 1
          }
        ),
        children: [
          /* @__PURE__ */ e.jsx(
            m,
            {
              icon: o.icon,
              className: a("!h-8 !w-8", {
                "text-green": t,
                "text-blue": s
              })
            }
          ),
          /* @__PURE__ */ e.jsx(
            "h4",
            {
              className: a({
                "text-green-dark": t,
                "text-black": s
              }),
              children: o.title
            }
          ),
          /* @__PURE__ */ e.jsx("p", { className: "p1 text-grey-400", children: o.description }),
          r !== l.length - 1 && /* @__PURE__ */ e.jsx(
            "div",
            {
              className: a(
                "absolute left-1/2 top-full h-8 w-[1px] -translate-x-1 translate-y-[1px] md:-end-8 md:left-auto md:top-1/2 md:h-[1px] md:w-8 md:translate-x-[1px] md:translate-y-2",
                {
                  "bg-green": t,
                  "bg-blue": s
                }
              )
            }
          )
        ]
      },
      r
    )) }),
    /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx("span", { className: "text-sm text-grey-400", children: "Individual results may vary. Always consult a qualified health professional to determine if a treatment plan is right for you." }) })
  ] });
};
export {
  y as default
};
